module.exports = __webpack_public_path__ + "static/media/menu-equipe.8d71ec3f.svg";